import axios from "axios";
import { getToken } from "@/utils/auth";
import errorCode from "@/utils/errorCode";
import { ElMessage } from "element-plus";
import jsonBigint from "json-bigint";

const service = axios.create({
  baseURL: "/api/storeroom",
  timeout: 6000000,
  // 解决浏览器在ID超过16位精度丢失问题
  transformResponse: [
    function (data) {
      const json = jsonBigint({
        storeAsString: true,
      });
      const res = json.parse(data);
      return res;
    },
  ],
  header: {
    "Content-Type": "application/json;charset=utf-8",
  },
});

service.interceptors.request.use(
  async (config) => {
    config.headers = {
      ...config.headers,
    };
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false;
    if (getToken() && !isToken) {
      config.headers["Zh-Token"] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
      config.headers["atomToken"] = getToken();
    }
    if (
      config.type === "formData" &&
      config.data &&
      config.data.constructor != FormData
    ) {
      var data = new FormData();
      for (var key in config.data) {
        var val = config.data[key];
        if (val === null || val === undefined) {
          data.append(key, "");
        } else if (val.constructor == Array) {
          for (var i = 0; i < val.length; i++) {
            data.append(
              key,
              typeof val[i] == "object" ? JSON.stringify(val[i]) : val[i]
            );
          }
        } else {
          data.append(key, typeof val == "object" ? JSON.stringify(val) : val);
        }
      }
      config.data = data;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (res) => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 2000;
    // 获取错误信息
    const msg = res.data.message || errorCode["default"];
    if (code.includes("B.Auth")) {
      ElMessage({
        message: msg,
        type: "error",
      });
        window.$goPage("/login");
      return Promise.reject(msg);
    } else if (code !== "2000") {
      ElMessage({
        message: msg,
        type: "error",
      });
      return Promise.reject("error");
    } else {
      return res.data;
    }
  },
  (error) => {
    if (error.response) {
      const data = error.response.data;
      const errCode = data.code;
    }
    return Promise.reject(error);
  }
);

export default service;
